/**
 * The site-images preview route. Its own module (no imports) because HttpClient's 401 branch needs it,
 * and importing it from `statics.service` would cycle through `api/index` back into HttpClient.
 *
 * A 401 on this path means "the backoffice preview link expired", not "the session expired" — it must
 * reject to the caller instead of logging the user out.
 */
export const SITE_IMAGES_PREVIEW_PATH = "statics/site_images/preview";
